import React, { useImperativeHandle } from 'react';
import CheckAll from './icons/CheckAll';
import CheckNone from './icons/CheckNone';
import classNames from 'classnames';

// Styled checkbox
const Checkbox = React.forwardRef((props, ref) => {
    const { checked, onChange, disabled, readonly, name, label, className } = props;

    useImperativeHandle(ref, () => ({
        click: () => {
            // Don't allow clicks on disabled or readonly checkboxes
            if (disabled || readonly) return;
            onChange({ target: { name, checked: !checked } });
        },
    }));

    const handleClick = () => {
        // Don't allow clicks on disabled or readonly checkboxes
        if (disabled || readonly) return;

        onChange({ target: { name, checked: !checked } });
    };

    return (
        <div className={classNames('styled-checkbox', className)}>
            {checked ? (
                <CheckAll onClick={handleClick} disabled={disabled} />
            ) : (
                <CheckNone onClick={handleClick} disabled={disabled} />
            )}
            <label className="form-check-label">{label}</label>
        </div>
    );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
